import { useTranslation } from 'react-i18next'
import { Box, Typography } from '@mui/material'
import AlreadyRegisteredWrapper from 'app/auth/components/onboarding/steps/shared/AlreadyRegisteredWrapper'
import { useOnboardingContext } from '../../use-onboarding-context'
import { useApplicationName } from 'hooks/use-application-name'

const AlreadyRegisteredVAT = () => {
  const { t } = useTranslation()
  const { duplicationData } = useOnboardingContext()
  const { appName } = useApplicationName()

  return (
    <AlreadyRegisteredWrapper>
      <Box my={2}>
        <Typography component='div' variant='body1' style={{ whiteSpace: 'pre-line' }}>
          {t('Auth.AlreadyRegisteredMessageVAT1', { appName })}
        </Typography>
        <Typography component='div' variant='body1' style={{ whiteSpace: 'pre-line' }}>
          {t('Auth.AlreadyRegisteredMessageVAT2', { shopNumber: duplicationData?.dupe.ID })}
        </Typography>
      </Box>
    </AlreadyRegisteredWrapper>
  )
}

export default AlreadyRegisteredVAT
